import { observer } from 'mobx-react-lite';

import { MobileScreen } from 'components/MobileScreen';
import { useStore } from 'hooks/useStore';

import { Content } from '../Content';

const Mobile = () => {
  const {
    app: { i18n },
    filter: {
      resetFirms,
      firms: { isDefault },
    },
  } = useStore();

  const actions = {
    second: {
      onClick: resetFirms,
      text: i18n.common.reset,
    },
  };

  return (
    <MobileScreen hasBackButton actions={isDefault ? undefined : actions} title={i18n.firms.label}>
      <Content />
    </MobileScreen>
  );
};

const connected = observer(Mobile);

export { connected as Mobile };
